export const ACTIVATE = 'syncTransaction.ACTIVATE';
export const DEACTIVATE = 'syncTransaction.DEACTIVATE';
